import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { LOGOUT_URL } from "../common/constants/ApplicationUrl";
import { logout } from "../common/dependencies/action/action";
import { storage } from "../common/dependencies/store/stoarage";
import api from '../common/dependencies/utils/Api';
const Logout = (props) => {
  const { history, logout } = props;

  useEffect(async () => {
    
    if (logout) {
      const token = await storage.getRefreshToken();
      localStorage.clear();
      api.POST(LOGOUT_URL, { refresh_token: token })
        .then((response) => {
          const { status, data } = response;
          if (status === 200) {
              localStorage.clear();
    localStorage.removeItem("SavedLoggedInData");
    localStorage.removeItem("loggedIn");
            history.push("/login");
            return response;
            
          } else {
            return Promise.reject(response.data);
          }
        });
    }
  }, []);
  return <div></div>;
};

export default connect(null, { logout })(withRouter(Logout));
